import React from 'react'

// Centered empty-state block — icon + title + optional hint. Used by the three
// "nothing selected yet" branches on the voice-agents page (info
// pane, canvas, node drawer) so they share one visual treatment instead of
// each rendering a bare line of text.
//
// `action` is an optional node (a link or button) rendered under the hint, for
// dead-end states the user needs a way out of rather than just an explanation.
const EmptyState = ({ icon: Icon, title, hint, action, dataTestId }) => (
  <div className="voice-agents__empty-state" data-testid={dataTestId}>
    {Icon && (
      <div className="voice-agents__empty-state-icon" aria-hidden="true">
        <Icon size={36} stroke={1.4} />
      </div>
    )}
    <div className="voice-agents__empty-state-title">{title}</div>
    {hint && <div className="voice-agents__empty-state-hint">{hint}</div>}
    {action && <div className="voice-agents__empty-state-action">{action}</div>}
  </div>
)

export default EmptyState
